import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http' ;
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './login/login.component';
import { ProductspageComponent } from './productspage/productspage.component';
import { RegisterComponent } from './register/register.component';
import { MenOversizedPlainComponent } from './men-oversized-plain/men-oversized-plain.component';
import { MenOversizedPrimtedComponent } from './men-oversized-primted/men-oversized-primted.component';
import { WomenOversizedPrintedComponent } from './women-oversized-printed/women-oversized-printed.component';
import { WomenOversizedPlainComponent } from './women-oversized-plain/women-oversized-plain.component';
import { ViewProductsComponent } from './view-products/view-products.component';
import { ViewCartComponent } from './view-cart/view-cart.component';
import { LoginSignupWithOtpComponent } from './login-signup-with-otp/login-signup-with-otp.component';
import { ShippingPolicyComponent } from './shipping-policy/shipping-policy.component';
import { ReturnAndRefundPolicyComponent } from './return-and-refund-policy/return-and-refund-policy.component';
import { TermsOdServicePolicyComponent } from './terms-od-service-policy/terms-od-service-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { NewArrivalsComponent } from './new-arrivals/new-arrivals.component';
import { BestsellersComponent } from './bestsellers/bestsellers.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './AuthInterceptor';
import { OrderComponent } from './order/order.component';
import { PaymentComponent } from './payment/payment.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountComponent } from './account/account.component';
import { AddressComponent } from './address/address.component';

@NgModule({
  declarations: [ 
    AppComponent,
    LandingPageComponent,
    LoginComponent,
    ProductspageComponent,
    RegisterComponent,
    MenOversizedPlainComponent,
    MenOversizedPrimtedComponent,
    WomenOversizedPrintedComponent,
    WomenOversizedPlainComponent,
    ViewProductsComponent,
    ViewCartComponent,
    LoginSignupWithOtpComponent,
    ShippingPolicyComponent,
    ReturnAndRefundPolicyComponent,
    TermsOdServicePolicyComponent,
    PrivacyPolicyComponent,
    NewArrivalsComponent,
    BestsellersComponent,
    OrderComponent,
    PaymentComponent,
    AccountComponent,
    AddressComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
